import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IGioCongDongActionTypes } from "../../action-types/gio-cong-dong/IGioCongDongActionTypes";
import { IGioCongDongReducer } from "../../page-state-model/gio-cong-dong/IGioCongDongReducer";
const iniState: IGioCongDongReducer = {
    status: ePageBaseStatus.is_not_initialization,
    gioCongDongs: []
}
export const gioCongDongReducer = (state: IGioCongDongReducer = iniState, action: IGioCongDongActionTypes): IGioCongDongReducer => {
    switch (action.type) {
        case "GIO_CONG_DONG_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "GIO_CONG_DONG_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                gioCongDongs: action.payload
            }
        case "GIO_CONG_DONG_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                gioCongDongs: []
            }
        case "GIO_CONG_DONG_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "GIO_CONG_DONG_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "GIO_CONG_DONG_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "GIO_CONG_DONG_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "GIO_CONG_DONG_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "GIO_CONG_DONG_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "GIO_CONG_DONG_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "GIO_CONG_DONG_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }

        default:
            return state;
    }
}